import React, { Component } from 'react';
import { Container, Row, Col, Card, Button, CardImg, CardTitle, CardText, CardDeck,
 CardSubtitle, CardBlock } from 'reactstrap';
import Perro from '../../../public/chihuahua.jpg';

export default class Perros extends Component {
  render() {
    return (
        <Container>
            <Row>
                <Col xs="9">
                    <CardDeck>
                        <Card>
                            <CardImg top width="200px" height="190px" src={Perro} alt="Card image cap"/>
                            <CardBlock>
                                <CardTitle>Chihuahua</CardTitle>
                                <CardSubtitle>Raza Pequeña</CardSubtitle>
                                <CardText>El chihuahueño (también denominado chihuahua fuera de México) es una raza de
                                    perro originaria de México. Recibe su nombre del estado mexicano de Chihuahua, lugar
                                    donde fue descubierto.</CardText>
                                <Button>Leer más</Button>
                            </CardBlock>
                        </Card>
                        <Card>
                            <CardImg top width="200px" height="190px" src={Perro} alt="Card image cap"/>
                            <CardBlock>
                                <CardTitle>Doberman</CardTitle>
                                <CardSubtitle>Raza Mediana</CardSubtitle>
                                <CardText>El dóberman es una raza relativamente reciente, debe su nombre al alemán Karl
                                    Friedrich Louis Dobermann, quien a finales del siglo XIX, emprende la tarea de crear
                                    una nueva ...</CardText>
                                <Button>Leer más</Button>
                            </CardBlock>
                        </Card>
                        <Card>
                            <CardImg top width="200px" height="190px" src={Perro} alt="Card image cap"/>
                            <CardBlock>
                                <CardTitle>Labrador</CardTitle>
                                <CardSubtitle>Raza Mediana</CardSubtitle>
                                <CardText>El Labrador retriever —también conocido como Cobrador de Labrador o Perdiguero
                                    de Labrador — es una raza canina originaria de Terranova, en la actual Canadá. Es la
                                    raza más popular del mundo por la cantidad de ejemplares registrados</CardText>
                                <Button>Leer más</Button>
                            </CardBlock>
                        </Card>
                    </CardDeck>
                </Col>
                <Col>
                    <Card block inverse style={{backgroundColor: '#009688', borderColor: '#999'}}>
                        <CardTitle>Sabias Que?</CardTitle>
                        <CardText>LOS PERROS PUEDEN DETECTAR LAS EMOCIONES DE LOS HUMANOS DE ACUERDO CON EL TONO DE
                            VOZ.</CardText>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Home/index.js